module.exports = __webpack_public_path__ + "img/playCorrect.5238d674.svg";